// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.s0[data-v-75c20362] { fill: url(#g1)\n}\n.s1[data-v-75c20362] { fill: #0078d4\n}\n.s2[data-v-75c20362] { fill: url(#g2)\n}\n.s3[data-v-75c20362] { fill: url(#g3)\n}\n.s4[data-v-75c20362] { fill: #2b98e1\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
